import WSSDataProvider from './WssDataProvider';
import {diff, applyChange} from 'deep-diff';
import Vue from 'vue';
import checksum from 'json-checksum';
export function newId() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8); // eslint-disable-line
    return v.toString(16);
  });
}
export default class CmsClient {
  constructor(config: any, store: any) {
    this.config = config;
    this.wss = new WSSDataProvider(config.wssUrl, config.httpUrl, this.wsMessage, this.wsOpen, this.wsClose);
    if (store) {
      store.registerModule('CmsClient', this.store());
    }
  }
  wsMessage(message: any): void {} // eslint-disable-line
  wsOpen(e: WSSDataProvider): void {
    if (!e.store) {
      return;
    }
    e.store.commit('SET_STATUS', true);
  }
  wsClose(e: WSSDataProvider): void {
    if (!e.store) {
      return;
    }
    e.store.commit('SET_STATUS', false);
  }
  private store(): any {
    const cmsClient = this; // eslint-disable-line
    return {
      getters: {
        saving(state: any) {
          return state.pendingEvents.length !== 0;
        },
        orderedComponents(state: any) {
          const comps = JSON.parse(JSON.stringify(state.local)).components;
          if (!comps) {
            return [];
          }
          return Object.keys(comps).sort((a: string, b: string) => {
            return comps[a].order - comps[b].order;
          }).map((key: string) => {
            return comps[key];
          });
        },
        document(state: any) {
          return JSON.parse(JSON.stringify(state.local));
        },
      },
      state: {
        componentSummaries: null,
        components: {},
        remote: {},
        local: {},
        pendingEvents: [],
        sentEvents: [],
        isOpen: false,
        subscriptions: {},
        subscribers: {},
        toc: {},
        message: null,
        messages: [],
        events: [],
        createdDocumentId: null,
      },
      actions: {
        async getComponentSummaries(context: any): Promise<any> {
          // const url = cmsClient.config.httpUrl + 'v1/codeArtifact/componentSummaries';
          const url = 'https://wzwa9qql31.execute-api.us-west-2.amazonaws.com/557/v1/codeArtifact/componentSummaries';
          const response = await fetch(url);
          const json = await response.json();
          context.commit('SET_COMPONENT_SUMMARIES', json.data);
          return json;
        },
        async getComponentDetails(context: any, payload: any): Promise<any> {
          const uComponentName = encodeURIComponent(payload.pkg);
          const uComponentVersion = encodeURIComponent(payload.version);
          // const url = cmsClient.config.httpUrl + 'v1/codeArtifact/componentDetails';
          const url = `https://wzwa9qql31.execute-api.us-west-2.amazonaws.com/557/v1/codeArtifact/componentDetails?componentName=${uComponentName}&componentVersion=${uComponentVersion}`;
          const response = await fetch(url);
          const json = await response.json();
          context.commit('SET_COMPONENT_DETAILS', json.data);
          return json;
        },
        async connect(context: any): Promise<void> {
          return new Promise((success) => {
            cmsClient.wss.connect(async () => {
              cmsClient.store = context;
              context.commit('SET_STATUS', true);
              await context.dispatch('subscribe', {
                channelId: 'toc-changes',
                callback: (e: any) => {
                  context.commit('UPDATE_TOC', e);
                },
              });
              success();
            });
          });
        },
        disconnect(): void {
          cmsClient.wss.disconnect();
        },
        async subscribe(context: any, payload: any): Promise<void> {
          await cmsClient.wss.subscribe(payload.channelId, payload.callback);
        },
        async addEvent(context: any, payload: any): Promise<void> {
          await cmsClient.wss.addEvent(payload);
        },
        async publish(context: any, payload: any): Promise<void> {
          await cmsClient.wss.publish(payload);
        },
        async getToc(context: any): Promise<void> {
          let toc;
          try {
            toc = await cmsClient.wss.getToc();
          } catch (err) {
            throw new Error('Cannot get TOC:' + err);
          }
          context.commit('SET_TOC', toc);
        },
        unsubscribe(context: any, payload: any): void {
          cmsClient.wss.unsubscribe(payload.channelId, payload.callback);
        },
        sendToAll(context: any, payload: any): void {
          cmsClient.wss.sendToAll(payload);
        },
        sendToChannel(context: any, payload: any): void {
          cmsClient.wss.sendToChannel(payload.channelId, {
            channelId: payload.channelId,
            value: {
              channelId: payload.channelId,
              response: payload.value,
            },
          });
        },
        sendToConnection(context: any, payload: any): void {
          cmsClient.wss.sendToConnection(payload.connectionId, payload);
        },
        async subscribeToDocument(context: any, payload: any): Promise<void> {
          await context.dispatch('subscribe', {
            channelId: `${payload.documentId}-events`,
            callback: (e: any) => {
              context.dispatch('receiveChange', e);
            },
          });
        },
        async openDocument(context: any, payload: any): Promise<void> {
          let doc: any;
          try {
            doc = await cmsClient.wss.getDocument(payload.documentId, payload.version);
          } catch (err) {
            throw new Error('Cannot open document:' + err);
          }
          await context.dispatch('subscribeToDocument', {
            documentId: doc.id,
          });
          const changes = diff({}, doc);
          // apply to local
          context.commit('SET_LOCAL_CHANGES', {changes,});
          // apply to remote
          context.commit('SET_REMOTE_CHANGES', {changes,});
        },
        async createDocument(context: any): Promise<string> {
          const doc = {
            id: newId(),
            version: 0,
            name: '',
            description: '',
            components: {},
          };
          await context.dispatch('subscribeToDocument', {
            documentId: doc.id,
          });
          const changes = diff({}, doc);
          context.commit('SET_LOCAL_CHANGES', {
            changes,
          });
          await context.dispatch('applyChange', doc);
          context.commit('SET_CREATED_DOCUMENT_ID', doc.id);
          return doc.id;
        },
        receiveChange(context: any, payload: any): void {
          console.info('<-- Receive Event ---', JSON.parse(JSON.stringify(payload)));
          // get event from remote
          // apply to remote
          context.commit('SET_REMOTE_CHANGES', payload);
          // 1 check if own event
          context.commit('ADD_EVENTS', payload);
          const ev = context.state.pendingEvents.find((e: any) => {
            return e.id === payload.id;
          });
          // apply to remote
          context.commit('SET_REMOTE_CHANGES', payload);
          if (ev) {
            context.commit('REMOVE_PENDING', ev);
            return;
          }
          // apply to local
          context.commit('SET_LOCAL_CHANGES', payload);
        },
        changeDocument(context: any, payload: any) {
          const changes = diff(context.state.local, JSON.parse(JSON.stringify(payload)));
          if (changes) {
            context.commit('SET_LOCAL_CHANGES', {
              changes,
            });
          }
        },
        async applyChange(context: any): Promise<void> {
          const documentId = context.state.local.id;
          // check for diff
          const preVersionChanges = diff(context.state.remote, context.state.local);
          if (!preVersionChanges) {
            return;
          }
          // tick version
          context.commit('SET_LOCAL_VERSION', context.state.local.version + 1);
          // generate diff
          const changes = diff(context.state.remote, context.state.local);
          // if there are no changes send warning
          if (!changes) {
            console.warn('EventSourceClient: sendChange: called without any apparent changes.');
            return;
          }
          // calculate CRC32
          const sha256 = (checksum as any)(context.state.local);
          // generate event
          const event = {
            id: newId(),
            documentId,
            changes,
            sha256,
            version: context.state.local.version,
          };
          // add to pending queue
          context.commit('SET_PENDING', event);
          // send to remote
          console.info('--- Send Event -->', JSON.parse(JSON.stringify(event)));
          await context.dispatch('addEvent', event);
        },
      },
      mutations: {
        SET_COMPONENT_SUMMARIES(state: any, payload: any) {
          state.componentSummaries = payload;
        },
        SET_COMPONENT_DETAILS(state: any, payload: any) {
          Vue.set(state.components, `${payload.packageName}:${payload.version}`, payload);
          state.componentDetails = payload;
        },
        UPDATE_TOC(state: any, payload: any) {
          Vue.set(state.toc, payload.sk, {
            epochMils: new Date().getTime(),
            id: payload.state.id,
            userId: payload.state.userId || 'Unknown',
            version: payload.state.version,
          });
        },
        SET_TOC(state: any, payload: any) {
          state.toc = payload;
        },
        ADD_EVENTS(state: any, payload: any) {
          state.events.push(payload);
        },
        SET_STATUS(state: any, payload: any) {
          state.isOpen = payload;
        },
        SET_PENDING(state: any, payload: any) {
          state.pendingEvents.push(payload);
          state.sentEvents.push(payload);
        },
        REMOVE_PENDING(state: any, payload: any) {
          state.pendingEvents.splice(state.pendingEvents.indexOf(payload), 1);
        },
        SET_REMOTE_CHANGES(state: any, payload: any) {
          const target = JSON.parse(JSON.stringify(state.remote));
          payload.changes.forEach((change: any) => {
            applyChange(target, true, change);
          });
          Vue.set(state, 'remote', target);
        },
        SET_CREATED_DOCUMENT_ID(state: any, payload: any) {
          state.createdDocumentId = payload;
        },
        SET_LOCAL_VERSION(state: any, payload: any) {
          state.local.version = payload;
        },
        SET_LOCAL_CHANGES(state: any, payload: any) {
          const target = JSON.parse(JSON.stringify(state.local));
          payload.changes.forEach((change: any) => {
            applyChange(target, true, change);
          });
          Vue.set(state, 'local', target);
        },
      },
    }
  }
  /** Vue plugin installer */
  install(): void {} // eslint-disable-line
  /** Configuration */
  config: any;
  wss: WSSDataProvider;
}
